<template>
    <div>
      <label>Valutazione Settori</label>
      <div class="row" v-if="show_course">
          <div class="col-3">
            {{ __("forms.SatisfactionSurvey.courseSector") }}
          </div>
          <div class="col-9">
              {{course}}
          </div>
      </div>
      <div class="row" v-if="show_trainers">
        <div class="col-3">
          {{ __("forms.SatisfactionSurvey.trainersSector") }}
        </div>
        <div class="col-9">
          {{trainers}}
        </div>
      </div>
      <div class="row" v-if="show_tutors">
        <div class="col-3">
          {{ __("forms.SatisfactionSurvey.tutorsSector") }}
        </div>
        <div class="col-9">
          {{tutors}}
        </div>
      </div>
      <div class="row" v-if="show_training_agency">
        <div class="col-3">
          {{ __("forms.SatisfactionSurvey.TrainingAgencySector") }}
        </div>
        <div class="col-9">
          {{training_agency}}
        </div>
      </div>
    </div>
</template>

<script>
export default {

    mounted() {

    },
    data () {
        return {
          course : 0,
          trainers : 0,
          tutors : 0,
          training_agency : 0,
          //booleans show/hide avg
          show_course: false,
          show_trainers: false,
          show_tutors: false,
          show_training_agency: false,

        }
    },
    methods: {

    },
    props: {


    }
}
</script>

<style>
  /*.custom-actions button.ui.button {
    padding: 8px 8px;
  }
  .custom-actions button.ui.button > i.icon {
    margin: auto !important;
  }*/
</style>
